/* eslint-disable no-unused-vars */
import React from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { message } from "../../Redux/redux";

const PopupModal = React.forwardRef((props) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(message());
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    // console.log('>>formData', Object.fromEntries(formData.entries()));
    props.onHide(); // Hide the modal after form submission

    // formData.append("access_key", "b3e05231-a97f-4182-8c24-be343a2b0119");
    formData.append("access_key", "33cd9103-ca0f-4da7-a39b-f094aef113e2");
    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
    }
  };
  return (
    <Modal
      show={props.show}
      size="lg"
      onHide={props.onHide}
      centered
      className="popupmodel mt-3"
    >
      <Modal.Header closeButton className="model-header">
        <Modal.Title id="contained-modal-title-vcenter">
          <Row>
            <Col>
              <p className="m-0">Contact Us</p>
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmit}>
          <Row>
            <Col xs={12} md={12} lg={6}>
              <Row>
                <p>Basic Details</p>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <TextField
                    id="name"
                    name="name"
                    label="Name"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                    autoFocus
                  />
                </Col>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <TextField
                    id="designation"
                    name="designation"
                    label="Designation"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <TextField
                    id="companyName"
                    name="companyName"
                    label="Company Name"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <p>Contact</p>
                  <TextField
                    id="officialEmail"
                    name="officialEmail"
                    label="Official Email ID"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <TextField
                    id="mobileNo"
                    name="mobileNo"
                    label="Mobile No"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
                <Col sm={12} lg={12} xl={12} className="mb-3">
                  <p>Address</p>
                  <TextField
                    id="address"
                    name="address"
                    label="Address"
                    variant="outlined"
                    fullWidth
                    className="custom-textfield"
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
              </Row>
            </Col>

            <Col xs={12} md={12} lg={6}>
              <Row>
                <Col md={12} lg={12} className="mb-3">
                  <p>Requirements</p>
                  <TextField
                    id="requirement"
                    name="requirement"
                    label="Requirement"
                    multiline
                    rows={7}
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Col>
                <Col>
                  <Row>
                    <Col sm={12} lg={12} xl={12} className="mb-3">
                      <p>Preferred Time Slot For Overview</p>
                      <TextField
                        id="timeSlot1"
                        name="timeSlot1"
                        label="DD/MM/YY-HH:MM-AM"
                        variant="outlined"
                        fullWidth
                        className="custom-textfield"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Col>
                    <Col sm={12} lg={12} xl={12} className="mb-3">
                      <TextField
                        id="timeSlot2"
                        name="timeSlot2"
                        label="DD/MM/YY-HH:MM-AM"
                        variant="outlined"
                        fullWidth
                        className="custom-textfield"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Col>
                    <Col sm={12} lg={12} xl={12} className="mb-3">
                      <TextField
                        id="timeSlot3"
                        name="timeSlot3"
                        label="DD/MM/YY-HH:MM-AM"
                        variant="outlined"
                        fullWidth
                        className="custom-textfield"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <hr />
            <Col>
              <button type="submit" onClick={handleClick} className="main-btn">
                Submit
              </button>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default PopupModal;
